<!-- /components/ToastManager.vue -->
<template>
  <!-- 使用 transition-group, 保留原先的 slide-fade 過場效果 -->
  <transition-group name="slide-fade" tag="div" class="toast-outer-container">
    <div
      v-for="(toast, index) in toasts"
      :key="toast.id"
      class="toast-message"
      :class="`toast-${toast.type}`"
      :style="getToastStyle(toast, index)"
    >
      {{ toast.text }}
    </div>
  </transition-group>
</template>

<script setup>
import { computed } from 'vue'
import { useToastStore } from '@/store/toastStore.js'

const toastStore = useToastStore()
const toasts = computed(() => toastStore.toasts)

/**
 * 根據是否有 anchorEl 決定 Toast 的定位方式
 */
function getToastStyle(toast, index) {
  // 1. 沒有指定 anchorEl → 顯示在右上角 (照舊)
  const NAVBAR_HEIGHT = 80  // 你可自行調整，比如 80px
  if (!toast.anchorEl) {
    return {
      position: 'fixed',
      top: `${NAVBAR_HEIGHT + (index * 60)}px`, // 多加個 NAVBAR_HEIGHT
      right: '20px',
      zIndex: 99999,
    }
  }

  // 2. 有指定錨點 → 顯示在該元素上方 (此範例只做簡單示範)
  const rect = toast.anchorEl.getBoundingClientRect()
  // 考慮使用者有可能已經向下捲動：要加上 scrollY
  const scrollY = window.scrollY || document.documentElement.scrollTop

  return {
    position: 'absolute',
    left: rect.left + 'px',
    top: (rect.top + scrollY - 50) + 'px',  // 往上 50px
    zIndex: 99999,
    // 若想固定寬度，可以加 width
    // width: rect.width + 'px'
  }
}
</script>

<style scoped>
/* 外層容器，可以是 relative，但為方便此範例，直接讓它佔整個 body */
.toast-outer-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  /* height: 100%;  // 是否需要視情況而定 */
  pointer-events: none; /* Toast本身不一定需要互動 */
}

/* Toast 的基本外觀 */
.toast-message {
  pointer-events: auto;
  background: #fff;
  padding: 10px 15px;
  margin-bottom: 10px;
  color: #333;
  border-radius: 4px;
  box-shadow: 0 2px 5px rgba(0,0,0,0.2);
  transition: all 0.5s ease;
  /* 讓它最上層顯示 */
}

/* =========== 過場動畫 =========== */
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.5s ease;
}
.slide-fade-enter {
  opacity: 0;
  transform: translateY(-20px);
}
.slide-fade-leave-to {
  opacity: 0;
  transform: translateY(20px);
}

/* info: 淺黃色 */
.toast-info {
  background: #fff7c0;
}
/* success: 淺綠色 */
.toast-success {
  background: #d4f5d2;
}
/* warning: 淺橘色 */
.toast-warning {
  background: #ffe1ac;
}
/* error: 淺紅色 */
.toast-error {
  background: #ffcccc;
}
</style>
